
import { useEffect, useState } from "react";
import { supabase } from "@/integrations/supabase/client";
import { User } from "@supabase/supabase-js";

export const useCollectionsFetcher = (user: User | null) => {
  const [collections, setCollections] = useState<any[]>([]);
  const [isLoading, setIsLoading] = useState(false);
  const [error, setError] = useState<Error | null>(null);

  useEffect(() => {
    const fetchCollections = async () => {
      if (!user) return;
      
      setIsLoading(true);
      setError(null);
      
      try {
        const { data, error } = await supabase
          .from("collections")
          .select("*")
          .eq("user_id", user.id)
          .order("position", { ascending: true });

        if (error) throw error;
        
        setCollections(data || []);
      } catch (err: any) {
        console.error("Error fetching collections:", err);
        setError(err);
      } finally {
        setIsLoading(false);
      }
    };

    fetchCollections();
  }, [user]);

  return { collections, isLoading, error };
};
